import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function SignupForm() {
  const { refresh } = useAuth();
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.auth.signup({
        companyName,
        email,
        password,
        name: name || undefined,
      });
      await refresh();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="signup-companyName">会社名</Label>
        <Input
          id="signup-companyName"
          value={companyName}
          onChange={e => setCompanyName(e.target.value)}
          placeholder="株式会社 Example"
          required
          className="rounded-lg"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="signup-email">メールアドレス</Label>
        <Input
          id="signup-email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="admin@example.com"
          required
          className="rounded-lg"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="signup-password">パスワード</Label>
        <Input
          id="signup-password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          minLength={8}
          className="rounded-lg"
        />
        <p className="text-xs text-muted-foreground">8 文字以上</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="signup-name">お名前（任意）</Label>
        <Input
          id="signup-name"
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="山田 太郎"
          className="rounded-lg"
        />
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
      <Button type="submit" className="w-full rounded-lg" disabled={loading}>
        {loading ? "登録中…" : "登録する"}
      </Button>
    </form>
  );
}

